App.AiBrainEntries = (function() {
  var openModal = null;

  function closeModal() {
    if (!openModal) return;
    openModal.setAttribute("hidden", "hidden");
    document.body.classList.remove("ai-brain-modal-open");
    openModal = null;
  }

  function showModal(modal) {
    if (!modal) return;
    if (openModal && openModal !== modal) closeModal();
    modal.removeAttribute("hidden");
    document.body.classList.add("ai-brain-modal-open");
    openModal = modal;
    var closeButton = modal.querySelector(".ai-brain-topic-modal__close");
    if (closeButton && typeof closeButton.focus === "function") closeButton.focus();
  }

  function init() {
    document.addEventListener("click", function(event) {
      var opener = event.target.closest("[data-ai-brain-modal-open]");
      if (opener) {
        event.preventDefault();
        showModal(document.getElementById(opener.getAttribute("data-ai-brain-modal-open")));
        return;
      }
      if (event.target.closest("[data-ai-brain-modal-close]")) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener("keydown", function(event) {
      if (event.key === "Escape") closeModal();
    });
  }

  return { init: init };
})();
